import { ssoErrorReducer } from './sso/sso-error.reducer';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

export const rootReducer = history =>
  combineReducers({
    sso: ssoErrorReducer,
    router: connectRouter(history),
  });
